export default {
  breadcrumb: {
    platform: '平台运营后台',
    staff: '员工管理',
    add: '添加员工',
    edit: '编辑员工'
  },
  button: {
    back: '返回',
    cancel: '取消',
    save: '保存',
    search: '搜索',
    refresh: '刷新',
    addUser: '添加用户',
    detail: '详情',
    edit: '编辑',
    more: '更多',
    disable: '禁用用户',
    enable: '启用用户',
    resetPwd: '重置密码',
    delete: '删除组织架构',
    confirmDelete: '确定删除',
    confirm: '确定'
  },
  form: {
    baseInfo: '基本信息',
    org: '组织架构',
    permission: '权限设置',
    third: '第三方系统集成',
    username: '用户名',
    email: '邮箱',
    phone: '手机号',
    status: '用户状态',
    branches: '归属分公司',
    departments: '归属部门',
    roles: '全部角色',
    supervisors: '上级主管',
    cargoWareId: 'CargoWare用户ID',
    eTowerId: 'eTower用户ID',
    remark: '备注',
    usernamePlaceholder: '请输入用户名',
    emailPlaceholder: '请输入邮箱',
    phonePlaceholder: '请输入手机号',
    statusPlaceholder: '请选择用户状态',
    branchesPlaceholder: '请选择归属分公司',
    departmentsPlaceholder: '请选择归属部门',
    rolesPlaceholder: '请选择授权角色',
    supervisorsPlaceholder: '请选择上级主管',
    cargoWareIdPlaceholder: '请输入CargoWare用户ID',
    eTowerIdPlaceholder: '请输入eTower用户ID',
    remarkPlaceholder: '请输入备注信息（可选）',
    usernameRequired: '请输入用户名',
    usernameMin: '用户名至少2个字符',
    emailRequired: '请输入邮箱',
    emailValid: '请输入有效的邮箱地址',
    phoneRequired: '请输入手机号',
    phoneValid: '请输入有效的手机号',
    statusRequired: '请选择用户状态',
    branchesRequired: '请选择归属分公司',
    departmentsRequired: '请选择归属部门',
    rolesRequired: '请选择授权角色',
    saveSuccess: '员工已添加',
    updateSuccess: '员工信息已更新',
    avatarUpload: '上传头像',
    currentStatus: '当前状态',
    pendingTip: '新员工创建后默认为待激活状态，首次登录后，自动激活',
    addOrgGroup: '添加组织架构',
    orgGroupIndex: '组织架构 {index}',
    orgGroupIncomplete: '请先填写完整已有的组织架构（分公司和部门）',
    orgGroupRequired: '请至少选择一个完整的组织架构（分公司和部门）',
    orgGroupAtLeastOne: '至少需要保留一个组织架构',
    mainOrgGroup: '主组织架构',
    setAsMainOrgGroup: '设为主组织架构',
    wechatWorkUserid: '企微ID',
    wechatWorkUseridPlaceholder: '请输入企微ID',
    englishName: '英文名称',
    englishNamePlaceholder: '请输入英文名称',
    landline: '座机电话',
    countryCode: '国家代码',
    areaCode: '区号',
    landlineNumberPlaceholder: '座机号码'
  },
  status: {
    active: '正常',
    inactive: '禁用',
    pending: '待激活',
    unknown: '未知'
  },
  stats: {
    total: '总用户数',
    active: '活跃用户',
    inactive: '禁用用户',
    pending: '待激活'
  },
  table: {
    id: '用户ID',
    userInfo: '用户信息',
    contact: '联系方式',
    branches: '归属分公司',
    departments: '归属部门',
    roles: '授权角色',
    supervisors: '上级主管',
    status: '状态',
    lastLogin: '最后登录',
    createTime: '创建时间',
    action: '操作',
    wechatWorkUserid: '企微ID',
    englishName: '英文名称',
    landline: '座机电话'
  },
  detail: {
    title: '用户详情',
    avatar: '用户头像',
    username: '用户名',
    email: '邮箱地址',
    phone: '手机号',
    branches: '所属公司',
    roles: '用户角色',
    status: '用户状态',
    lastLogin: '最后登录',
    createTime: '创建时间',
    id: '用户ID',
    wechatWorkUserid: '企微ID'
  },
  modal: {
    disableTitle: '禁用用户确认',
    enableTitle: '启用用户确认',
    disableConfirm: '⚠️ 禁用确认',
    enableConfirm: '✅ 启用确认',
    disableText: '将会禁用用户 {username}，禁用后该用户将无法登录系统，是否确认？',
    enableText: '将会启用用户 {username}，启用后该用户可正常登录系统，是否确认？',
    disableNote: '注意：禁用后用户无法访问系统，但用户数据仍会保留',
    enableNote: '注意：启用后用户将恢复正常的系统访问权限',
    resetPwdTitle: '重置密码确认',
    resetPwdConfirm: '⚠️ 操作确认',
    resetPwdText: '将会重置用户 {username} 的登录密码，是否确认？',
    resetPwdNote: '注意：密码重置后将生成随机8位密码，并自动发送至用户邮箱',
    deleteTitle: '确定要删除这个用户吗？',
    deleteContent: '删除后用户 {username} 的所有信息将无法恢复'
  },
  message: {
    searchSuccess: '搜索完成',
    refreshSuccess: '数据已刷新',
    showAll: '显示全部用户',
    showActive: '筛选活跃用户',
    showInactive: '筛选禁用用户',
    showPending: '筛选待激活用户',
    autoFilter: '已自动筛选企业：{company}',
    resetPwdSuccess: '已重置用户 {username} 的密码',
    deleteSuccess: '用户 {username} 已删除',
    disableSuccess: '用户 {username} 已禁用',
    enableSuccess: '用户 {username} 已启用',
    pleaseFillInCompleteOrganizationStructure: '请先填写完整已有的组织架构（分公司和部门）',
    atLeastOneOrganizationStructureRequired: '至少需要保留一个完整的组织架构（分公司和部门）',
    formValidateFailed: '表单校验失败，请检查输入项',
    employeeUpdatedSuccessfully: '员工信息修改成功',
    employeeAddedSuccessfully: '员工信息添加成功',
    atLeastOneMainRequired: '必须保留一个主组织架构',
    exactlyOneMainRequired: '有且只能有一个主组织架构'
  },
  options: {
    roles: {
      superAdmin: '超级管理员',
      deptManager: '部门经理',
      csManager: '客服经理',
      user: '普通用户',
      ops: '运营专员',
      financeManager: '财务经理',
      hr: '人事专员',
      techLead: '技术主管',
      productManager: '产品经理',
      marketing: '市场专员'
    },
    branches: {
      hll: '货拉拉物流科技有限公司',
      hllSouth: '货拉拉华南分公司',
      sf: '顺丰速运集团',
      sfNorth: '顺丰华北分公司',
      db: '德邦物流股份有限公司',
      dbEast: '德邦华东分公司',
      zt: '中通快递股份有限公司',
      st: '申通快递有限公司'
    },
    departments: {
      logistics: '物流部门',
      tech: '技术部门',
      cs: '客服部门',
      marketing: '市场部门',
      ops: '运营部门',
      finance: '财务部门',
      audit: '审计部门',
      hr: '人事部门',
      product: '产品部门'
    },
    supervisors: {
      zhangsan: '张三',
      lisi: '李四',
      wangwu: '王五',
      zhaoliu: '赵六',
      chenqi: '陈七',
      sunba: '孙八',
      zhoujiu: '周九'
    }
  },
  title: {
    addEmployee: '添加员工',
    editEmployee: '编辑员工'
  }
}
